import * as React from 'react'

import { StarRating } from '@syconium/little-miss-figgy'

import { Body, RatingText, StarsWrap, TotalReviews } from './styles'

export const StarDistribution: React.FC<{
  rating: number
  totalReviews: number
}> = ({ rating, totalReviews }) => {
  const fixedRating = rating.toFixed(1)

  return (
    <Body>
      <StarsWrap>
        <StarRating
          rating={Number(fixedRating)}
          starSize={{
            sm: `18px`,
            md: `24px`,
          }}
        />
        <TotalReviews>({totalReviews})</TotalReviews>
      </StarsWrap>
      <RatingText>{fixedRating}/5</RatingText>
    </Body>
  )
}
